/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const da__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24t`
};

const de__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const en__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const es__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const fr__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const hu__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const it__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const nl__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24u`
};

const pl__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const pt__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

const sv__24h = /** @type {(inputs: {}) => string} */ () => {
	return `24h`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const _24h = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr._24h(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("_24h", locale)
	if (locale === "cs") return cs__24h(inputs)
	if (locale === "da") return da__24h(inputs)
	if (locale === "de") return de__24h(inputs)
	if (locale === "en") return en__24h(inputs)
	if (locale === "es") return es__24h(inputs)
	if (locale === "fr") return fr__24h(inputs)
	if (locale === "hu") return hu__24h(inputs)
	if (locale === "it") return it__24h(inputs)
	if (locale === "nl") return nl__24h(inputs)
	if (locale === "pl") return pl__24h(inputs)
	if (locale === "pt") return pt__24h(inputs)
	return sv__24h(inputs)
};
export { _24h as "24h" }